export const URL_IMG = {
    default:'assets/img/',
    alert:'assets/img/icon__exclamation__cabaret.svg',
    countries:'assets/img/countries/',
    default_country:'assets/img/countries/mx.svg',
    arrowdown_blue:'assets/img/img-arrowdown__astronaut.svg',
    arrows_white:'assets/img/img-arrows__white.svg',
    pdf_blue:'assets/img/img-pdf__astronaut.svg',
    return_blue:'assets/img/img-return__glaucous.svg',
    close_white:'assets/img/img-close__white.svg',
    close_blue: 'assets/img/img-close__astronaut.svg',
    question_blue:'assets/img/img-question__astronaut.svg',
    check_blue: 'assets/img/img-check__astronaut.svg',
    check_white: 'assets/img/img-check__white.svg',
    down_blue: 'assets/img/img-down__glaucous.svg',
    logo_blue: 'assets/img/logo-bursanet__astronaut.svg',
    logo_white: 'assets/img/logo-bursanet__white.svg',    
    right_blue : 'assets/img/img-right__glaucous.svg',
    check__white : 'assets/img/icon__check__white.svg',
    check__slim : 'assets/img/icon__check-slim__astronaut.svg',
    social_network: {
        facebook:'assets/img/img-facebook__astronaut.svg',
        ex:'assets/img/img-x__astronaut.svg',
        instagram:'assets/img/img-instagram__astronaut.svg'
    }
};
 
export const URL_EXT = {
    social_network:{
        facebook:'https://www.facebook.com/BursanetMX/',
        ex:'https://x.com/bursanetmx',
        linkedin:'https://www.linkedin.com/company/bursanetmx/',
        instagram:'https://www.instagram.com/bursanetmx/'
    },
    documents: {
        terminos:'https://www.actinver.com/documents/74160/111212/TerminosCondiciones.pdf/1c1399be-cca4-4047-35c6-c371ca95a47c?t=1590445360894',
        aviso: 'https://www.actinver.com/web/actinver/casa-de-bolsa',
        curp:'https://www.gob.mx/curp/'
    }    
};

export const COUNTRY = {
    descripcionError:null,
    land1:"US",
    landk:"USA",
    landx:"EE.UU.",
    natio:"ESTADOUNIDENSE",
    pfisc:5,
    spras:"S",
    valReturn:1000
};